import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { LuInfo, LuStar, LuCircleAlert } from 'react-icons/lu';

function InfoNe() {
  const { t } = useTranslation();
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-yellow-50 py-20 px-4">
      {/* Decorative Background Elements */}
      <div className="fixed inset-0 overflow-hidden -z-10">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-yellow-200/20 to-orange-200/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-200/20 to-purple-200/20 rounded-full blur-3xl"></div>
      </div>

      <motion.div 
        className="max-w-4xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Header */}
        <motion.div 
          className="text-center mb-16"
          variants={itemVariants}
        >
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm border border-yellow-200/50 rounded-full px-4 py-2 mb-4 shadow-lg">
            <LuStar className="w-4 h-4 text-yellow-500" />
            <span className="text-sm font-medium text-gray-700">{t('infoNe.badge')}</span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('infoNe.heading_line1')}{" "}
            <span className="bg-gradient-to-r from-yellow-500 to-orange-500 bg-clip-text text-transparent">
              {t('infoNe.heading_highlight')}
            </span>
          </h1>

          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('infoNe.subtitle')}
          </p>
        </motion.div>

        {/* En développement */}
        <motion.div
          className="bg-white rounded-[2rem] p-8 md:p-10 mb-10 shadow-xl border border-yellow-100 flex flex-col items-center"
          variants={itemVariants}
        >
          <div className="flex items-center mb-6">
            <div className="p-2 bg-yellow-100 rounded-xl mr-4">
              <LuCircleAlert className="w-6 h-6 text-yellow-600" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900">
              {t('infoNe.developing_heading')}
            </h2>
          </div>
          <p className="text-lg text-gray-700 leading-relaxed mb-4 text-center">
            {t('infoNe.developing_body')}
          </p>
          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6 text-yellow-700 text-center max-w-lg">
            {t('infoNe.developing_note1')}<br />
            {t('infoNe.developing_note2')}
          </div>
        </motion.div>

        {/* Aperçu rapide */}
        <motion.div
          className="bg-white rounded-[2rem] p-8 md:p-10 shadow-xl border border-yellow-100"
          variants={itemVariants}
        >
          <div className="flex items-center mb-6">
            <div className="p-2 bg-yellow-100 rounded-xl mr-4">
              <LuInfo className="w-6 h-6 text-yellow-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900">
              {t('infoNe.preview_heading')}
            </h2>
          </div>
          <ul className="list-disc pl-6 text-gray-700 space-y-3">
            <li>{t('infoNe.preview_item1')}</li>
            <li>{t('infoNe.preview_item2')}</li>
            <li>{t('infoNe.preview_item3')}</li>
            <li>{t('infoNe.preview_item4')}</li>
          </ul>
          <div className="mt-6 p-4 bg-gradient-to-r from-yellow-100 to-orange-100 rounded-xl text-gray-700">
            {t('infoNe.preview_note')}
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default InfoNe;
